<template>
    <Tabs value="0">
        <TabList>
            <Tab value="0">{{ TR.info }}</Tab>
            <Tab v-if="!G.privateIfNotAdmin()" value="1">{{ TR.permission }}</Tab>
            <!-- <Tab value="2">Header III</Tab> -->
        </TabList>
        <TabPanels>
        <TabPanel value="0">
            <!-- <template #header>
                <i class="fas fa-info-circle me-2"></i>
                <span>{{ TR.info }}</span>
            </template> -->
            <DynamicTable2 v-bind:mainref="mainref" :data="data"></DynamicTable2>
        </TabPanel>

        <TabPanel v-if="!G.privateIfNotAdmin()" value="1">
            <!-- <template #header>
                <i class="fas fa-user-cog me-2"></i>
                <span>{{ TR.permission }}</span>
            </template> -->
            <!-- <div style="overflow-y: scroll; height: calc( 100vh - 300px ); max-height: calc( 100vh - 300px );"> -->
            <div>
                <table class="table table-hover table-bordered1 text-center">
                    <thead class="table-secondary border-secondary">
                        <tr class="table-secondary border-secondary">
                            <th class="align-middle">{{ TR['perm_routes'] }}</th>
                            <th>{{ TR['perm_view'] }}
                                <div class="form-switch">
                                    <input class="form-check-input cursor-pointer fs-6" type="checkbox" role="switch" v-model="allRouteCheckStatus.view" @change="setAllRouteChecked('view')" />
                                </div>
                            </th>
                            <th>{{ TR['perm_add'] }}
                                <div class="form-switch">
                                    <input class="form-check-input cursor-pointer fs-6" type="checkbox" role="switch" v-model="allRouteCheckStatus.add" @change="setAllRouteChecked('add')" />
                                </div>
                            </th>
                            <th>{{ TR['perm_update'] }}
                                <div class="form-switch">
                                    <input class="form-check-input cursor-pointer fs-6" type="checkbox" role="switch" v-model="allRouteCheckStatus.update" @change="setAllRouteChecked('update')" />
                                </div>
                            </th>
                            <th>{{ TR['perm_remove'] }}
                                <div class="form-switch">
                                    <input class="form-check-input cursor-pointer fs-6" type="checkbox" role="switch" v-model="allRouteCheckStatus.remove" @change="setAllRouteChecked('remove')" />
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- <template v-for="(item, index) in G.userPageAccess.value.filter(e => e.role == 'sysadmin')[0].permission.map(a => !G.ignored_routes.includes(a.route) ? a : undefined )" :key="index"> -->
                        <template v-for="(item_route, index) in routeList" :key="index">
                            <tr v-if="item_route !== undefined">
                                <td class="text-start">{{ TR[`perm_${item_route}`] || item_route }}</td>
                                <td>
                                    <div class="form-switch">
                                        <input class="form-check-input cursor-pointer fs-6" type="checkbox" role="switch" v-model="PERM[item_route]['view']" @change="checkAllRouteCheckStatus(item_route, 'view')"
                                        />
                                        <!-- :checked="PO['role_permission'][item_route].indexOf('view') !== -1 ? true : false"  -->
                                    </div>
                                </td>
                                <td>
                                    <div class="form-switch">
                                        <input class="form-check-input cursor-pointer fs-6" type="checkbox" role="switch" v-model="PERM[item_route]['add']" @change="checkAllRouteCheckStatus(item_route, 'add')"
                                        />
                                        <!-- <input class="form-check-input cursor-pointer fs-6" type="checkbox" v-model="PERM[item_route]['add']" :checked="PO['role_permission'][item_route].indexOf('add') !== -1 ? true : false" @change="setRouteChecked(item_route, 'add')" /> -->
                                    </div>
                                </td>
                                <td>
                                    <div class="form-switch">
                                        <input class="form-check-input cursor-pointer fs-6" type="checkbox" role="switch" v-model="PERM[item_route]['update']" @change="checkAllRouteCheckStatus(item_route, 'update')"
                                        />
                                        <!-- <input class="form-check-input cursor-pointer fs-6" type="checkbox" v-model="PERM[item_route]['update']" :checked="PO['role_permission'][item_route].indexOf('update') !== -1 ? true : false" @change="setRouteChecked(item_route, 'update')" /> -->
                                    </div>
                                </td>
                                <td>
                                    <div class="form-switch">
                                        <input class="form-check-input cursor-pointer fs-6" type="checkbox" role="switch" v-model="PERM[item_route]['remove']" @change="checkAllRouteCheckStatus(item_route, 'remove')"
                                        />
                                        <!-- <input class="form-check-input cursor-pointer fs-6" type="checkbox" v-model="PERM[item_route]['remove']" :value="{'route': item_route, 'perm': 'remove'}" :checked="PO['role_permission'][item_route].indexOf('remove') !== -1 ? true : false" @change="setRouteChecked(item_route, 'remove')" /> -->
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
                <!-- <span v-html="G.userPageAccess.value.filter(e => e.role == 'sysadmin')[0].permission.map(a => !G.ignored_routes.includes(a.route) ? (a.route + ' - ' + (a.action !== undefined ? a.action : '')) : null).join('<br />')"></span> -->
            </div>
        </TabPanel>
        </TabPanels>
    </Tabs>
</template>

<script>
import { onBeforeMount, ref, reactive, watchEffect } from "vue";

import { useStore } from "@/system_modules/store";

import Tabs from "primevue/tabs";
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { G } from "@/_common";
import { useModelWrapper } from "@/system_modules/utils/modelWrapper";

import DynamicTable2 from "@/components/table/DynamicTable2";

export default {
    name: 'RolePermissionPage',
    components:{
        DynamicTable2,
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
    },
    props:{
        mainref: {
            type: Object
        },
        data: {
            type: Object
        },
        routes: {
            type: Object
        },
    },
    setup(props, {emit}) {
        const store = useStore();
        const TR = ref({});
        const PERM = ref({});
        const selectedRole = ref('');
        const rolePermission = ref([]);
        const routeList = ref([]);
        const allRouteCheckStatus = reactive({
            "view": false,
            "add": false,
            "update": false,
            "remove": false,
        });

        const PO = useModelWrapper(props, emit, "mainref");
        PO.value['newdata'] = {};
        PO.value['newdata']['role_permission'] = {};

        const checkAllRouteCheckStatus = (route, permis) => {
            // if( PERM.value[route][permis] != undefined && PERM.value[route][permis] ){
            //     PO.value['role_permission'][route].push(permis);
            // }
            // else if( PERM.value[route][permis] != undefined && PERM.value[route][permis] == false ){
            //     PO.value['role_permission'][route].splice( PO.value['role_permission'][route].indexOf(permis), 1 );
            // }

            let a = 0;
            routeList.value.map(r => {
                if(PERM.value[r][permis] !== undefined && PERM.value[r][permis] == true){
                    a++;
                }
            });
            if( routeList.value.length == a ){
                allRouteCheckStatus[permis] = true;
            }
            else{
                allRouteCheckStatus[permis] = false;
            }
        };

        const setAllRouteChecked = (permis) => {
            routeList.value.map(r => {
                PERM.value[r][permis] = allRouteCheckStatus[permis];
            });
        };

        watchEffect(() => {
            TR.value = store.getTranslation();
            PO.value['newdata']['role_permission'] = PERM.value;
        });

        onBeforeMount(() => {
            selectedRole.value = props.data.data.slug;
            routeList.value = props.data.routes;
            let pobj = JSON.parse(props.data.data.permission || '[]');
            // rolePermission.value = G.userPageAccess.value.filter(e => e.role == selectedRole.value)[0].permission.map( r => !G.ignored_routes.includes(r.route) ? r : undefined );
            // rolePermission.value = pobj  ? pobj.filter(a => !G.ignored_routes.includes(a.route) ) : [];
            rolePermission.value = pobj && pobj.length ? pobj.filter(a => !G.ignored_routes.includes(a.route) ) : [];

            routeList.value.forEach(item => {
                PO.value['newdata']['role_permission'][item] = [];
                PERM.value[item] = {};
            });
            // rolePermission.value.forEach(p => { if(p != undefined) PERM.value[p.route] = p.action; });
            rolePermission.value.forEach(p => {
                // if(p != undefined) PO.value['role_permission'][p.route] = p.action;
                if( PERM.value[p.route] === undefined ){
                    PERM.value[p.route] = {};
                }
                p.action.forEach(a => PERM.value[p.route][a] = true);
            });
            Object.keys(allRouteCheckStatus).forEach( s => checkAllRouteCheckStatus('', s));
        });

        return {
            G,
            TR,
            PERM,
            PO,
            routeList,

            selectedRole,
            rolePermission,

            checkAllRouteCheckStatus,
            allRouteCheckStatus,
            setAllRouteChecked,
        };
    }
}

</script>
